<template lang="pug">
.header
  .toolbar
    router-link(:to="back" v-if="!disableBack"): svg(viewBox="0 0 24 24")
      path(fill="currentColor", d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")
    router-link(to="/menu"): svg(viewBox="0 0 24 24" v-if="!disableHome")
      path(fill="currentColor", d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z")
    router-link(to="/"): svg(viewBox="0 0 24 24" v-if="!disableClose")
      path(fill="currentColor", d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z")
  h1 

</template>

<script>
export default {
  props: ['disable-back', 'disable-home', 'disable-close', 'back']
};
</script>

<style scoped>
  .toolbar{
    float: right;
    margin-top: 30px;
  }
  .toolbar svg {
    margin-left: 20px;
    width: 46px;
    height: 46px;
    cursor: pointer;
  }
</style>
